import AuthUtils from './AuthUtils';
import refreshAccessToken from './TokenRefresher';
import store from '../store';
import { showLockScreen, } from '../actions/auth';

class TokenRefreshManager {
  constructor() {
    this.refreshTimer = null;
    this.CHECK_INTERVAL = 60000; // Check every minute
    this.REFRESH_BEFORE_EXPIRY = 5 * 60 * 1000; // Refresh 5 minutes before expiry
  }

  start() {
    this.stop(); // Clear any existing timer
    this.refreshTimer = setInterval(() => {
      this.checkAndRefreshToken();
    }, this.CHECK_INTERVAL);
  }

  stop() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  async checkAndRefreshToken() {
    const { auth = {}, } = store.getState();
    const { authentication = {}, } = auth;
    const { token, } = authentication;

    if (!token) {
      this.stop();
      return;
    }

    try {
      const tokenData = JSON.parse(atob(atob(token).split(':')[0]));
      const expirationTime = new Date(tokenData.expiration).getTime();
      const currentTime = Date.now();
      const timeUntilExpiry = expirationTime - currentTime;

      // If token will expire soon, refresh it
      if (timeUntilExpiry > 0 && timeUntilExpiry < this.REFRESH_BEFORE_EXPIRY) {
        await this.refreshToken();
      } else if (timeUntilExpiry <= 0) {
        // Token already expired, show lock screen
        console.log('Token expired, showing lock screen');
        this.stop();
        store.dispatch(showLockScreen());
      }
    } catch (error) {
      console.error('Error checking token expiration:', error);
      // Invalid token format, show lock screen
      console.log('Invalid token, showing lock screen');
      this.stop();
      store.dispatch(showLockScreen());
    }
  }

  async refreshToken() {
    try {
      const token = await refreshAccessToken();
      console.log('Token refreshed successfully');
      return token;
    } catch (error) {
      console.error('Token refresh error:', error);
      this.stop();
      // Mid-session, a failed refresh means the user's open work is at stake — lock
      // rather than log out, so the page survives behind the overlay.
      store.dispatch(showLockScreen());
      throw error;
    }
  }

  // Get time until token expires in milliseconds
  getTimeUntilExpiry() {
    const { auth = {}, } = store.getState();
    const { authentication = {}, } = auth;
    const { token, } = authentication;

    if (!token || !AuthUtils.isTokenValid(token)) {
      return 0;
    }

    try {
      const tokenData = JSON.parse(atob(atob(token).split(':')[0]));
      const expirationTime = new Date(tokenData.expiration).getTime();
      return Math.max(0, expirationTime - Date.now());
    } catch {
      return 0;
    }
  }
}

export default new TokenRefreshManager();
